import { Controller } from "@hotwired/stimulus";

// Starts the download its link points at; the browser saves the file and leaves the page in place
export default class extends Controller {
  connect() {
    this.start = () => {
      this.disconnect();
      window.location = this.element.href;
    };
    // After the page has loaded, when the analytics tracker reports the view; a hung tracker must not hold it up.
    if (document.readyState === "complete") {
      this.start();
    } else {
      window.addEventListener("load", this.start);
      this.timer = setTimeout(this.start, 2000);
    }
  }

  disconnect() {
    window.removeEventListener("load", this.start);
    clearTimeout(this.timer);
  }
}
